import { Crud } from '../../containers/crud/crud';
import { translate } from '../../../localization';
import { CrudForm } from '../../containers/crud/crudForm';
import { UpdateEntity } from '../../containers/updateEntity';
import { Switch } from 'antd';
import { useCrudData } from '../../containers/crud/crudContext';
import { WebCrud } from '../../containers/crud/webCrud';
export default function Faq() {
  const { refresh } = useCrudData();
  return (
    <WebCrud
      api="faq"
      FormComponent={(props) => (
        <CrudForm
          {...props}
          elements={[
            {
              type: 'text',
              name: 'title',
              label: 'Title',
              required: true,
              inputProps: {
                maxLength: 500,
              },
            },
            {
              type: 'text',
              name: 'category',
              label: 'Category',
              required: true,
              inputProps: {
                maxLength: 500,
              },
            },
            {
              type: 'textarea',
              name: 'description',
              label: 'Description',
              required: false,
            },
            {
              type: 'switch',
              name: 'published',
              label: 'Published',
              required: false,
            },
          ]}
        />
      )}
    >
      <Crud.Header title="Contact">
        <Crud.Header.Actions>
          <Crud.Header.Actions.Common />
        </Crud.Header.Actions>
      </Crud.Header>
      <Crud.Table
        columns={[
          {
            title: translate('common.title'),
            dataIndex: 'title',
          },
          {
            title: translate('faq.category.label'),
            dataIndex: 'category',
          },
          {
            title: translate('faq.published.label'),
            dataIndex: 'published',
            render: (value, record) => {
              return (
                <UpdateEntity
                  record={record}
                  getChildren={({ loading, updateEntity }) => {
                    return (
                      <Switch
                        loading={loading}
                        checked={record.published}
                        onChange={async (checked) => {
                          await updateEntity({ published: checked });
                          refresh();
                        }}
                      />
                    );
                  }}
                />
              );
            },
          },
        ]}
        actions={[
          ...Crud.Table.RowActions.Common,
          () => (
            <Crud.Table.RowActions.DuplicateRecordWithForm
              elements={[
                {
                  type: 'text',
                  label: 'Enter new title',
                  name: 'title',
                  inputProps: {
                    placeholder: 'title',
                  },
                },
              ]}
            />
          ),
        ]}
      >
        <Crud.Table.Header>
          <Crud.Search
            fields={[
              {
                type: 'text',
                name: 'title',
                inputProps: {
                  placeholder: translate('common.title'),
                },
              },
              {
                type: 'text',
                name: 'category',
                inputProps: {
                  placeholder: translate('faq.category.label'),
                },
              },
            ]}
          ></Crud.Search>
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
      </Crud.Table>
    </WebCrud>
  );
}
